<script>
import {Locale} from "vue-i18n";
import {disposeTooltipsByClass, getTooltipsByClass, setupTooltipsByClass} from "@/libs/Helpers";

export default {
  name: "TimeSeriesControl",
  emits: ["onDataClick", "onSelectAllClick", "onClearSelectionClick"],
  props: {
    propId: String,
    propLocale: Locale,
    propTooltipTriggerShow: {type: Boolean, default: false},
    propTooltipTriggerHide: {type: Boolean, default: false},
    propTooltipDelay: {type: Number, default: 10000},
    propLoadingData: {type: Boolean, default: true},
    propButtonDataDisabled: {type: Boolean, default: false},
    propButtonSelectAllDisabled: {type: Boolean, default: false},
    propButtonClearSelectionDisabled: {type: Boolean, default: true},
    propButtonsMultipleSelect: {type: Boolean, default: true}
  },
  watch: {
    propTooltipTriggerShow(newVal, oldVal) {
      this.tooltipsFunctionClearTimeout();
      this.createTooltip();
      setTimeout(this.tooltipsShowAll, 300);
    },
    propTooltipTriggerHide(newVal, oldVal) {
      this.tooltipsFunctionClearTimeout();
      this.tooltipsHideAll();
    },
    propLocale(newData, oldData) {
      this.$nextTick(this.createTooltip);
    }
  },
  data() {
    return {
      tooltipsShown: false,
      tooltipHideFunction: null,
    }
  },
  methods: {
    onDataClick() {
      this.$emit("onDataClick");
    },
    onSelectAllClick() {
      this.$emit("onSelectAllClick");
    },
    onClearSelectionClick() {
      this.$emit("onClearSelectionClick");
    },
    createTooltip() {
      let tooltipClass = this.tooltipClassPoint;
      disposeTooltipsByClass(tooltipClass);
      setupTooltipsByClass(tooltipClass);
    },
    tooltipsShowAll() {
      let tooltipList = getTooltipsByClass(this.tooltipClassPoint);
      tooltipList.forEach(tooltip => {
        tooltip.show();
      });

      this.tooltipsFunctionClearTimeout();
      this.tooltipHideFunction = setTimeout(this.tooltipsHideAll, this.propTooltipDelay);
    },
    tooltipsHideAll() {
      let tooltipList = getTooltipsByClass(this.tooltipClassPoint);
      tooltipList.forEach(tooltip => {
        tooltip.hide();
      })
    },
    tooltipsFunctionClearTimeout() {
      if (this.tooltipHideFunction !== null) {
        clearTimeout(this.tooltipHideFunction);
        this.tooltipHideFunction = null;
      }
    }
  },
  computed: {
    tooltipClass() {
      return `tooltip-ts-${this.propId}`;
    },
    tooltipClassPoint() {
      return `.${this.tooltipClass}`
    },
    tooltipPlacement() {
      return 'left';
    }
  },
  mounted() {
    this.createTooltip();
    setTimeout(this.tooltipsShowAll, 300);
  },
  beforeUnmount() {
    this.tooltipsFunctionClearTimeout();
    this.tooltipsHideAll();
  }
}

</script>

<template>
  <div class="legend-buttons d-flex flex-column" :id="propId">
    <button class="btn btn-success btn-floating mb-1 border-2 border-dark"
            :disabled="propButtonDataDisabled || propLoadingData"
            :class="tooltipClass"
            :data-bs-title="$t('buttons.timeSeriesData')"
            :data-bs-placement="tooltipPlacement"
            @click="onDataClick">
      <div v-if="propLoadingData === true" class="spinner-grow spinner-grow-sm" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <i class="bi bi-graph-up" v-else></i>
    </button>
    <template v-if="propButtonsMultipleSelect">
      <button class="btn btn-warning btn-floating mb-1 border-2 border-dark"
              :disabled="propButtonSelectAllDisabled"
              :class="tooltipClass"
              :data-bs-title="$t('buttons.selectAll')"
              :data-bs-placement="tooltipPlacement"
              @click="onSelectAllClick">
        <i class="bi bi-check2-all"></i>
      </button>
      <button class="btn btn-danger btn-floating border-2 border-dark"
              :disabled="propButtonClearSelectionDisabled"
              :class="tooltipClass"
              :data-bs-title="$t('buttons.clearSelection')"
              :data-bs-placement="tooltipPlacement"
              @click="onClearSelectionClick">
        <i class="bi bi-x-circle"></i>
      </button>
    </template>
  </div>
</template>